import {
  AfterViewInit,
  Component, EventEmitter,
  Injector,
  Input, OnDestroy,
  OnInit, Output,
} from '@angular/core';
import {NgxFilterBase} from "../../ngx-filter-base";
import {Filter} from "../../../ngx-types";

@Component({
  selector: 'ngx-date-filter',
  templateUrl: '../../ngx-filter-double-template-base.html',
})
export class NgxDateFilterComponent extends NgxFilterBase implements OnInit, OnDestroy, AfterViewInit {

  startDate = new Date();

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  @Output() changeValue = new EventEmitter<any>();
  @Input() filter: Filter;

  get Label1(): string {
    if (this.filter) {
      if (this.filter.conditionOperator == this.conditionOperators.Between) {
        return (this.filterService.translator?.fromLabel) ? (this.filterService.translator.fromLabel) : 'from';
      } else {
        return this.filter?.options?.dateTimeOptions?.dateLabel ? (this.filter.options.dateTimeOptions.dateLabel) : 'Date';
      }
    }
    return '';
  }

  get Label2(): string {
    return this.filterService.translator?.toLabel ? (this.filterService.translator.toLabel) : 'to';
  }

  ngAfterViewInit(): void {
    this.generateComponents(this.filterService.filtersComponent.date, this.filter.options?.dateTimeOptions);
  }
}
